import * as React from 'react';

type FillColor = string;
type ClassName = string;

interface Props {
  fillColor: FillColor;
  className: ClassName;
}

const defaultProps = {
  className: '',
  fillColor: '#53585E',
};

const PauseIcon: React.SFC<Props> = ({
  fillColor,
  className,
}: Props): React.ReactElement<React.ReactNode> => (
  <svg
    viewBox="0 0 4 4"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0.2,0 L1.4,0 C1.51045695,-2.02906125e-17 1.6,0.08954305 1.6,0.2 L1.6,3.8 C1.6,3.91045695 1.51045695,4 1.4,4 L0.2,4 C0.08954305,4 4.12826506e-17,3.91045695 2.77555756e-17,3.8 L2.77555756e-17,0.2 C1.42285006e-17,0.08954305 0.08954305,4.80461881e-17 0.2,2.77555756e-17 Z M2.6,0 L3.8,0 C3.91045695,-2.02906125e-17 4,0.08954305 4,0.2 L4,3.8 C4,3.91045695 3.91045695,4 3.8,4 L2.6,4 C2.48954305,4 2.4,3.91045695 2.4,3.8 L2.4,0.2 C2.4,0.08954305 2.48954305,4.80461881e-17 2.6,2.77555756e-17 Z"
        fill={fillColor}
      />
    </g>
  </svg>
);

PauseIcon.defaultProps = defaultProps;

export default PauseIcon;
